
const fields = [
  {
    type: 'bsx-label',
    label: 'ID',
    model: 'id',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-label',
    inputType: 'text',
    label: '科別',
    model: 'name',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'first_diagnosis_required',
    required: true,
    textOn: '是',
    textOff: '否',
    valueOn: 'Y',
    valueOff: 'N',
  },
  {
    type: 'bsx-select',
    label: '單一初診 Dept 參數',
    model: 'first_diagnosis_dept',
    required: true,
    values: [
      { id: "gyn", name: "婦產科" },
      { id: "dentistry", name: "牙科" },
      { id: "paediatrics", name: "小兒科" },
    ],
    visible: (model) => model.first_diagnosis_required == 'Y',
    validator: function () {
      this.validation();
    },
  }
];

export default fields;
